export type ViewContext = 'UW' | 'DEFAULT';

export const HIDDEN_LEVEL = {
  FROM_AGENT: 'FROM_AGENT',
  FROM_UW: 'FROM_UW',
} as const;

export type HiddenLevel = (typeof HIDDEN_LEVEL)[keyof typeof HIDDEN_LEVEL];

export function shouldShowCoverage(
  coverage: { hiddenLevels?: HiddenLevel[] | null; isHidden?: boolean },
  viewContext: ViewContext = 'DEFAULT' // Non UW view
): boolean {
  // If hiddenLevels exists (array, even if empty), use it and ignore isHidden
  if (coverage.hiddenLevels !== undefined && coverage.hiddenLevels !== null) {
    const viewFlag =
      viewContext === 'DEFAULT' ? HIDDEN_LEVEL.FROM_AGENT : HIDDEN_LEVEL.FROM_UW;
    const hiddenForView = coverage.hiddenLevels.includes(viewFlag);
    // If hiddenLevels contains the view's flag, hide it; otherwise show it
    // Empty array [] means hidden from no one, so show it
    return !hiddenForView;
  }

  // Backward compatibility: fallback to isHidden only if hiddenLevels is not present
  // Agent view respects isHidden, UW view ignores it (shows everything)
  if (coverage.isHidden !== undefined) {
    return viewContext === 'UW' ? true : !coverage.isHidden;
  }

  // Default: show if no flags present
  return true;
}
